import { useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { ApprovalTimeline } from '../approval/ApprovalTimeline';

export interface OutcomePanelProps {
  result: { apBillId: string; status: 'POSTED' | 'PENDING_APPROVAL'; anomalyReasons: string[] };
  onNext: () => void;
}

export function OutcomePanel({ result, onNext }: OutcomePanelProps) {
  const navigate = useNavigate();
  const nextRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (result.status === 'POSTED') nextRef.current?.focus();
  }, [result.status]);

  if (result.status === 'POSTED') {
    return (
      <div className="card" style={{ padding: 16, display: 'grid', gap: 10 }} aria-live="polite">
        <div className="badge positive">✓ บันทึกและลงบัญชีแล้ว</div>
        {/* SPA navigation (not a raw <a> full reload) so the query-cache
            invalidation from the accept mutation isn't discarded. */}
        <button type="button" className="btn ghost" onClick={() => void navigate({ to: '/ap' })}>
          ดูใบตั้งหนี้ ({result.apBillId})
        </button>
        <button ref={nextRef} type="button" className="btn primary" onClick={onNext}>
          เอกสารถัดไป
        </button>
      </div>
    );
  }

  // PENDING_APPROVAL — accounting status != approval status (Design Z). Never
  // claim "saved/posted"; show WHY + a read-only chain.
  return (
    <div className="card" style={{ padding: 16, display: 'grid', gap: 10 }} aria-live="polite">
      <div className="badge warning">⏳ ส่งอนุมัติ 4 ตา</div>
      <div>
        <div className="meta" style={{ marginBottom: 4 }}>
          เหตุผลที่ต้องอนุมัติ:
        </div>
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {result.anomalyReasons.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
      </div>
      <ApprovalTimeline
        approvals={[]}
        isActive
        currentStep={1}
        emptyText="รอผู้ตรวจสอบดำเนินการที่หน้าตั้งหนี้ (/ap)"
        leadLine={<div className="meta">ส่งเข้าอนุมัติแล้ว — ดำเนินการต่อที่หน้า /ap</div>}
      />
      <button type="button" className="btn ghost" onClick={() => void navigate({ to: '/ap' })}>
        ไปที่หน้าอนุมัติ ({result.apBillId})
      </button>
    </div>
  );
}
